export default __webpack_public_path__ + "static/media/r6s_logo.ce003648.png";